import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject,
    _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/DependencyTree/nodes/GroupNodeContent/GroupNodeContent.styled.ts";

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
export var FolderWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & svg {\n    fill: rgba(0, 0, 61, 0.05);\n  }\n"])));